import React from 'react';
import { Box, Center, Heading, Image, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import unplugEvImg from '../../../assets/images/unplug_ev.svg';
import { ArcButton } from '../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';
import { COMPONENT_MIN_HEIGHT, TOP_NAV_SPACING_AFFORDANCE } from '../../../common/constants';
import { useParamBackUrl } from '../../../common/hooks/use-param-back-url';
import { useSetupBackUrl } from './use-setup-back-url';

/* istanbul ignore next -- @preserve */
export function UnplugEV() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // Defaults to the onboarding pairing screen; the Wi-Fi edit flow passes an explicit `setupBackURL`
  // query param (../device-wifi-configuration) so back navigation stays driven by the route,
  // not the global isEditing flag (which is never reset once set).
  const { setupBackURL, withSetupBackUrl } = useSetupBackUrl();
  const backURL = useParamBackUrl(setupBackURL ?? '../device-register?direction=back');

  return (
    <SlidingAnimationPageBase title={t('Common.device setup')} backURL={backURL} includeTopNavHamButton px={4}>
      <Box display="flex" flexDirection="column" h={`calc(${COMPONENT_MIN_HEIGHT} - ${TOP_NAV_SPACING_AFFORDANCE})`}>
        <Center pt={4} pb={2}>
          <Box position="relative" w="58vw" h="58vw">
            <Image data-testid="unplug-ev-image" src={unplugEvImg} alt="Unplug EV" w="100%" h="100%" />
          </Box>
        </Center>

        <VStack align="stretch" spacing={2} mb={2}>
          <Heading fontSize={24} fontWeight={600} textAlign="center">
            {t('Set Up Hardware.unplug ev')}
          </Heading>
        </VStack>

        <VStack align="stretch" spacing={2}>
          <Text data-testid="unplug-ev-text" textAlign="center">
            {t('Set Up Hardware.unplug ev text')}
          </Text>
        </VStack>

        <Center mt="auto" mb={5} flexDir={'column'}>
          <ArcButton
            data-testid="ev-charger-continue"
            onClick={() => navigate(withSetupBackUrl('../device-power-up-instructions'))}
            w="100%"
            py={6}
            mt="auto"
            arcColor="#3DCD57"
          >
            {t('Common.continue')}
          </ArcButton>
        </Center>
      </Box>
    </SlidingAnimationPageBase>
  );
}
